
import React from 'react';
import './About.css';

const About = () => {
  return (
    <>
    <div className='about-title'>
      <h1>About US</h1>
    </div>
     <div className="about-container">
     
      
      <div className="mission-content">
        <div className="mission-text">
          <h1>MISSION</h1>
          <p>
            At SSKV Techbuilds, our mission is to empower businesses with cutting-edge technology solutions that enable them to thrive in a digital world. We strive to build lasting partnerships with our clients, helping them navigate the complexities of technology and achieve their goals.
          </p>
        </div>
        <div className="mission-video">
          <video 
            controls 
            autoPlay 
            loop 
            muted 
            className="video"
          >
            <source 
              src="https://www.w3schools.com/html/mov_bbb.mp4"
              type="video/mp4" 
            />
            Your browser does not support the video.
          </video>
        </div>
      </div>

      <div className="about-content">
        <div className="about-image">
          <img 
            src="https://image3.jdomni.in/banner/31102023/DD/8A/86/578F9DE67C02C79193ED5C9C43_1698755307373.jpg?output-format=webp" 
            alt="SSKV Company" 
            className="photo"
          />
        </div>
        <div className="about-text">
        <h1>VALUES</h1>
          <p>
            A company crafted by aspirants with 6+ decades of experience combined, SSKV is driven by a core motto of Customer Satisfaction. With engineering excellence at its heart, we provide solutions that surpass client expectations.
          </p>
          <p>
            Our dedicated teams for Marketing, Design, Installation, and Service make us pioneers in designing Comfort Cooling & creating Comfort Workspaces.
          </p>
        </div>
      </div>

      <div className="culture-content">
        <div className="culture-text">
          <h1>CULTURE</h1>
          <p>
            At SSKV Techbuilds, we foster a collaborative and innovative culture that empowers our team to excel. We value diversity, creativity, and a commitment to excellence.
          </p>
        </div>
        <div className="culture-photos">
          <img 
            src="https://image2.jdomni.in/banner/02012023/4E/D6/48/0E6E71A2FAE0F463102C4D0A78_1672635687974.jpg?output-format=webp" 
            alt="Culture Photo 1" 
            className="photo"
          />
          <img 
            src="https://image2.jdomni.in/banner/02012023/4E/D6/48/0E6E71A2FAE0F463102C4D0A78_1672635687974.jpg?output-format=webp" 
            alt="Culture Photo 2" 
            className="photo"
          />
          <img 
            src="https://image2.jdomni.in/banner/02012023/4E/D6/48/0E6E71A2FAE0F463102C4D0A78_1672635687974.jpg?output-format=webp" 
            alt="Culture Photo 3" 
            className="photo"
          />
          <img 
            src="https://image2.jdomni.in/banner/02012023/4E/D6/48/0E6E71A2FAE0F463102C4D0A78_1672635687974.jpg?output-format=webp" 
            alt="Culture Photo 4" 
            className="photo"
          />
        </div>
      </div>
    </div>

    </>
   
  );
};

export default About;
